import { CREATING_ROLES } from "@/utils/UWorkspaces";

import { useAuth } from "./useAuth";

/**
 * Which workspaces the user may add projects to - a role there that edits
 * across it (OWNER, ADMIN, EDITOR), as the API decides - and whether one
 * given workspace is among them. Their own always is; so is any while
 * `/me` has not listed the workspaces yet (the API has the last word).
 */
export const useCanCreateInWorkspace = () => {
	const { user } = useAuth();
	const workspaces = user?.workspaces;

	const canCreateIn = (workspaceId?: number | null): boolean => {
		if (!workspaces || workspaceId == null) return true;
		const role = workspaces.find((w) => w.id === workspaceId)?.role;
		return !!role && CREATING_ROLES.includes(role);
	};

	return {
		canCreateIn,
		/** Where a new project may go, the user's own first (/me lists it first). */
		creatable: (workspaces ?? []).filter((w) =>
			CREATING_ROLES.includes(w.role)
		),
	};
};
